var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.description)?_c('div',[_c('h4',{staticClass:"sm:text-center mb-6"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('CollapsedContainer',[_c('RichTextContent',{attrs:{"content":_vm.description}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }